// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-js" + "-" + "1ce7b7154b5c36e75689" + ".js";
};